//apollo
import { useState } from 'react';
import { formatUTCDate, progressStatus } from '../../lib/utils/utils';
import { useRecoilState, useRecoilValue } from 'recoil';
import { itemsListAtom, orderDetailsActionAtom, orderDetailsDataAtom, productListAtom } from '../../state';
import { orderOption } from '../../lib/constant';

const MyOrderCard = ({ productSummary, setOrder }: any) => {

  const [selectedCard, setSelectedCard] = useState<any>(productSummary[0]);
  const [, setProductList] = useRecoilState<any>(productListAtom)
  const itemsList = useRecoilValue<any>(itemsListAtom)
  const [, setOrderDetailsAction] = useRecoilState<any>(orderDetailsActionAtom);
  const [, setOrderData] = useRecoilState<any>(orderDetailsDataAtom);

  const handleClick = (summary: any) => {
    setSelectedCard(summary?._id === selectedCard?._id ? null : summary);
    setOrder(summary);
    setOrderData({ project: "", job: "", paymentRef: "", designer: "" })
    setProductList(itemsList)
    setOrderDetailsAction({ project: false, job: false, paymentRef: false, designer: false });
  }

  return (
    <div className="h-screen overflow-auto">
      {productSummary?.map((summary: any, index: number) => {
        return <div
        id="temp"
            className={`p-0.5 bg-gray-100 rounded-[5px] flex flex-col justify-center w-full my-3 border-solid cursor-pointer !border !border-black ${
              selectedCard
                ? summary?.orderNumber === selectedCard?.orderNumber
                  ? '!border-black'
                  : '!border-transparent'
                : index === 0
                ? '!border-black'
                : '!border-transparent'
            }`}
            onClick={() => handleClick(summary)}>
          <div className="px-4 pt-3 pb-[13px] border-b border-gray-200 xl:flex lg:block flex justify-between items-center" >
            <div className="mr-3 self-stretch justify-center items-center inline-flex">
              <h4 className="text-gray-800 text-[15px] sm:text-[16px] font-bold m-0">Order</h4>
              <p className="m-0 justify-center items-center text-gray-800 text-[13px] sm:text-[15.12px]">#{summary?.orderNumber || ''}</p>
            </div>
            <p className="text-yellow-600 text-sm font-medium whitespace-nowrap m-0 bg-yellow-600 px-3 py-2 bg-opacity-[.15]">{orderOption?.find(x => x?.value === progressStatus(summary?.productSummary, ""))?.label || "Pending"}</p>
          </div>
          <div className="px-4 py-4">

          <div className="pb-[13px] grid grid-cols-[110px_1fr] items-center">
            <p className="text-[15.12px] m-0">Order Date</p>
            <p className="text-[15.12px] text-end lg:text-start xl:text-end xs:text-end m-0">{formatUTCDate(summary?.createdAt)}</p>
          </div>

          <div className="pb-[13px] grid grid-cols-[110px_1fr] items-center">
            <p className="text-[15.12px] m-0">Name</p>
            <p className="text-[15.12px] text-end lg:text-start xl:text-end xs:text-end m-0">{summary?.name || ''}</p>
          </div>
          </div>
        </div>
      })}
    </div>

  );

};
export default MyOrderCard;
